import { useEffect } from 'react';

export const useDocumentTitle = (title: string | number | undefined | null): void => {
	useEffect(() => {
		if (!title) return;

		const previousTitle = document.title;
		document.title = String(title);

		return () => {
			document.title = previousTitle;
		};
	}, [title]);
};
